import { Session } from 'smg/customer-api/session';
import { CategoryDescriptionsFromDocument, CopyFromDocument, InitEmailPreferencesPanel } from 'smg/email-preferences-page';
import { InitSmsPreferencesPanel } from 'smg/sms-preferences-panel';
import { AccountDetailsInit, RequireSession } from '../../account';

void main();

async function main() {
    if (await RequireSession()) {
        return;
    }

    await AccountDetailsInit();

    const smsPanel = InitSmsPreferencesPanel({
        mode: 'session',
        categoryDescriptions: CategoryDescriptionsFromDocument('#sprefs-categories'),
    });
    InitEmailPreferencesPanel({
        mode: 'session',
        categoryDescriptions: CategoryDescriptionsFromDocument(),
        copy: CopyFromDocument(),
        peers: [smsPanel],
    });
    // The current-user read the shared module makes carries no phone in
    // link mode, so the session is the one source of the number here.
    // The lede names the account, so it stays hidden until the session does.
    void Session().then(sess => {
        const $email = document.querySelector('#eprefs-email');
        if ($email) {
            $email.textContent = sess.user.email ?? '';
        }
        document.querySelector('#notifications-lede')?.classList.remove('d-none');
        smsPanel.setPhone(sess.user.phone ?? '');
    }).catch(() => undefined);
}
